import IconButton from 'components/atoms/button/IconButton';
import withModal from 'lib/helpers/hoc/withModal'
import { useDeleteLeads } from 'lib/hooks/mutations/Leads/useDeleteLeads';
import React, { FC } from 'react'
import { useTranslation } from 'react-i18next';


interface DeleteLeadProps {
    id: string;
    toggleModal?: () => void;
}

const DeleteLead: FC<DeleteLeadProps> = ({ id, toggleModal }) => {

    const { t } = useTranslation();

    const { mutateAsync, isLoading } = useDeleteLeads()


    const handleDelete = async () => {
        mutateAsync(id).then(() => {
            toggleModal && toggleModal();
        })

    };

    return (
        <div className="w-full">

            <p className="font-inter-medium text-[#282D46] text-[20px] mt-[10px]">
                {t(
                    "Are you sure you want to delete this lead? This action cannot be undone."
                )}
            </p>
            <div className="flex justify-end gap-5 mt-[53px]">
                <IconButton
                    onClick={toggleModal}
                    type="button"
                    className="w-full max-w-[150px]"
                    secondary={true}
                    disabled={isLoading}
                >
                    {t("Back")}
                </IconButton>
                <IconButton
                    onClick={handleDelete}
                    disabled={isLoading}
                    type="button"
                    className="w-full max-w-[150px]"
                >
                    {t("Delete")}
                </IconButton>
            </div>
        </div>
    )
}

export default withModal(DeleteLead)